import { render } from "./ChatPanel.vue?vue&type=template&id=34a7ea4a&scoped=true"
import script from "./ChatPanel.vue?vue&type=script&lang=js"
export * from "./ChatPanel.vue?vue&type=script&lang=js"

import "./ChatPanel.vue?vue&type=style&index=0&id=34a7ea4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a7ea4a"]])

export default __exports__